const CHUNK_ERROR_PATTERN =
  /ChunkLoadError|Loading chunk|Failed to load chunk|dynamically imported module|Importing a module script failed|error loading dynamically imported module/i;

const RSC_NAVIGATION_ERROR_PATTERN =
  /Failed to fetch RSC payload|unexpected response was received from the server|Invalid RSC payload/i;

function isRecoverableNavigationError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  return (
    error.name === 'ChunkLoadError' ||
    CHUNK_ERROR_PATTERN.test(error.message) ||
    RSC_NAVIGATION_ERROR_PATTERN.test(error.message)
  );
}

// React error-boundary entry point for a dropped client chunk OR a stale RSC
// flight after a deploy (HTML cache is not version-keyed). Delegates to the
// inline <head> script's healer (`window.__cmHealChunk`, see
// chunk-recovery-script.ts) which owns the guarded reload-with-fresh-marker so
// the logic lives in one place. Returns true when a reload was initiated
// (caller then renders a "recovering" state instead of the error UI).
export function recoverFromChunkError(error: unknown): boolean {
  if (typeof window === 'undefined' || !isRecoverableNavigationError(error)) {
    return false;
  }
  // biome-ignore lint/style/useNamingConvention: global hook name set by the inline head script
  const heal = (window as unknown as { __cmHealChunk?: () => boolean }).__cmHealChunk;
  return typeof heal === 'function' ? heal() : false;
}
